import { ChangeDetectionStrategy, Component, HostBinding, HostListener, Inject, OnInit, DOCUMENT } from '@angular/core';


@Component({
    selector: 'cw-contact-support',
    styleUrls: [
        'contact-support.component.scss'
    ],
    template: `
      <ng-content />`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})

export class CwContactSupportComponent implements OnInit {

    protected readonly CONTACT_LINK_SELECTOR = 'a.zp-footer__links__link';

    @HostBinding('class.state--active')
    protected contactLinkElement!: Element | null;

    constructor(
        @Inject(DOCUMENT) protected document: Document
    ) {
    }

    public ngOnInit(): void {
        this.contactLinkElement = this.document.querySelector(this.CONTACT_LINK_SELECTOR);
    }

    @HostListener('click')
    public onClick(): void {
        if (this.contactLinkElement) {
            this.contactLinkElement.dispatchEvent(new MouseEvent('click'));
        }
    }
}
